import { render, staticRenderFns } from "./CharacterItem.vue?vue&type=template&id=65f702b6&scoped=true"
import script from "./CharacterItem.vue?vue&type=script&lang=js"
export * from "./CharacterItem.vue?vue&type=script&lang=js"
import style0 from "./CharacterItem.vue?vue&type=style&index=0&id=65f702b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f702b6",
  null
  
)

export default component.exports